import React from 'react';

import { flagStyles } from '../settings';

const SvgPL = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-4248px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgPL;
